import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      brand: 'Astrology Times',
      home: 'Home',
      astrology: 'Astrology',
      vastu: 'Vastu',
      blog: 'Blog',
      about: 'About',
      contact: 'Contact',
      login: 'Login',
      signup: 'Sign Up',
      myAccount: 'My Account',
      logout: 'Logout',
      hero: {
        title: 'Unlock Your Cosmic Destiny',
        subtitle: '17 Years of Vedic Wisdom & Spiritual Guidance',
        cta: 'Book Consultation',
        freeTrial: 'First 10 Minutes FREE for New Clients'
      },
      services: {
        astrology: 'Astrology Services',
        vastu: 'Vastu Services',
        basic: 'Basic Reading',
        standard: 'Standard Reading',
        marriage: 'Marriage Consultation',
        career: 'Career & Business',
        dasha: 'Dasha & Remedies',
        perMinute: 'Pay Per Minute',
        basicReport: 'Basic Vastu Report',
        homeVideo: 'Home Vastu Video Call',
        officeVideo: 'Office/Shop Vastu Video Call',
        factoryVideo: 'Factory/Industrial Vastu Video Call',
        siteVisit: 'Site Visit (Custom Quote)'
      },
      booking: {
        selectDate: 'Select Date',
        selectTime: 'Select Time',
        infoBox: 'What do you want to know? (Optional)',
        bookNow: 'Book Now',
        payNow: 'Pay Now'
      },
      dashboard: {
        myProfile: 'My Profile',
        myBookings: 'My Bookings',
        myReports: 'My Reports',
        myInvoices: 'My Invoices',
        referFriend: 'Refer a Friend',
        loyaltyPoints: 'Loyalty Points',
        wallet: 'Wallet Balance'
      },
      footer: {
        aboutUs: 'About Us',
        services: 'Services',
        legal: 'Legal',
        disclaimer: 'Disclaimer',
        terms: 'Terms & Conditions',
        privacy: 'Privacy Policy',
        copyright: '© 2026 Astrology Times. All rights reserved.'
      }
    }
  },
  hi: {
    translation: {
      brand: 'एस्ट्रोलॉजी टाइम्स',
      home: 'होम',
      astrology: 'ज्योतिष',
      vastu: 'वास्तु',
      blog: 'ब्लॉग',
      about: 'हमारे बारे में',
      contact: 'संपर्क करें',
      login: 'लॉगिन',
      signup: 'साइन अप',
      myAccount: 'मेरा खाता',
      logout: 'लॉगआउट',
      hero: {
        title: 'अपनी ब्रह्मांडीय नियति को खोलें',
        subtitle: '17 वर्षों का वैदिक ज्ञान और आध्यात्मिक मार्गदर्शन',
        cta: 'परामर्श बुक करें',
        freeTrial: 'नए ग्राहकों के लिए पहले 10 मिनट मुफ्त'
      },
      services: {
        astrology: 'ज्योतिष सेवाएं',
        vastu: 'वास्तु सेवाएं',
        basic: 'बेसिक रीडिंग',
        standard: 'स्टैंडर्ड रीडिंग',
        marriage: 'विवाह परामर्श',
        career: 'करियर और व्यवसाय',
        dasha: 'दशा और उपाय',
        perMinute: 'प्रति मिनट भुगतान',
        basicReport: 'बेसिक वास्तु रिपोर्ट',
        homeVideo: 'होम वास्तु वीडियो कॉल',
        officeVideo: 'ऑफिस/शॉप वास्तु वीडियो कॉल',
        factoryVideo: 'फैक्ट्री/इंडस्ट्रियल वास्तु वीडियो कॉल',
        siteVisit: 'साइट विजिट (कस्टम कोट)'
      },
      booking: {
        selectDate: 'तारीख चुनें',
        selectTime: 'समय चुनें',
        infoBox: 'आप क्या जानना चाहते हैं? (वैकल्पिक)',
        bookNow: 'अभी बुक करें',
        payNow: 'अभी भुगतान करें'
      },
      dashboard: {
        myProfile: 'मेरी प्रोफाइल',
        myBookings: 'मेरी बुकिंग',
        myReports: 'मेरी रिपोर्ट',
        myInvoices: 'मेरे चालान',
        referFriend: 'दोस्त को रेफर करें',
        loyaltyPoints: 'लॉयल्टी पॉइंट्स',
        wallet: 'वॉलेट बैलेंस'
      },
      footer: {
        aboutUs: 'हमारे बारे में',
        services: 'सेवाएं',
        legal: 'कानूनी',
        disclaimer: 'अस्वीकरण',
        terms: 'नियम और शर्तें',
        privacy: 'गोपनीयता नीति',
        copyright: '© 2026 एस्ट्रोलॉजी टाइम्स। सर्वाधिकार सुरक्षित।'
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'hi',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;